import { render, staticRenderFns } from "./AppDatatablePagination.vue?vue&type=template&id=519bb56e&scoped=true&"
import script from "./AppDatatablePagination.vue?vue&type=script&lang=js&"
export * from "./AppDatatablePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "519bb56e",
  null
  
)

export default component.exports